import React from 'react'
import '../styles/ourClients.css'

function OurClients() {

    const images = [
        'Armada.png',
        'cremil.png',
        'Ejercito.png',
        'Gober.png',
        'inpec.png',
        'Manantial.jpg',
        'Policia.jpg',
        'Presencia.png',
        'Wesleyana.jpeg'
    ];

    return (
        <div className='container_slider text-center pt-5'>
            <span>Algunos de </span><span className='fw-bold'> nuestros clientes</span>
            <div className='container-xxxl slider d-flex justify-content-center align-items-center pb-5 pt-5'>

                <div className="slide-track container-xxl">
                    <div className="slide d-flex justify-content-center align-items-center">
                        {images.map((src, index) => (
                            <img key={index} src={`${process.env.PUBLIC_URL}/img/clients/${src}`} alt={`Defiendeme`} />
                        ))}
                        {images.map((src, index) => (
                            <img key={index} src={`${process.env.PUBLIC_URL}/img/clients/${src}`} alt={`Defiendeme`} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OurClients
